import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as FieldAction from './actions';
import { environment } from 'src/environments/environment';
import { IField } from '@app/models/field.model';
import { HttpService } from '@surveyname/common';

@Injectable()
export class FieldEffects {
  constructor(private http: HttpService, private action$: Actions) { }

  GetAllFields$: Observable<Action> = createEffect(() =>
  this.action$.pipe(
    ofType(FieldAction.GetAllFieldsAction),
    mergeMap(action =>
      this.http.get(`${environment.apiUrl}/field`).pipe(
        map((fields: IField[]) => {
          return FieldAction.AllFieldsLoadedAction({ payload: { fields } });
        }),
        catchError((error: Error) => {
          return of(FieldAction.ErrorFieldsAction(error));
        })
      )
    )
  )
);

  GetFields$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(FieldAction.GetFieldsAction),
      mergeMap(action =>
        this.http.get(`${environment.apiUrl}/project-type/fields/projectTypeId/${action.payload.typeId}`).pipe(
          map((fields: IField[]) => {
            return FieldAction.FieldsLoadedAction({ payload: { fields } });
          }),
          catchError((error: Error) => {
            return of(FieldAction.ErrorFieldsAction(error));
          })
        )
      )
    )
  );

  GetLibraryFields$: Observable<Action> = createEffect(() =>
  this.action$.pipe(
    ofType(FieldAction.GetLibraryFieldsAction),
    mergeMap(action =>
      this.http.get(`${environment.apiUrl}/project-type/fields/library/projectTypeId/${action.payload.typeId}`).pipe(
        map((fields: IField[]) => {
          return FieldAction.LibraryFieldsLoadedAction({ payload: { fields } });
        }),
        catchError((error: Error) => {
          return of(FieldAction.ErrorFieldsAction(error));
        })
      )
    )
  )
);

  GetFieldsByProject$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(FieldAction.GetFieldsByProjectAction),
      mergeMap(action =>
        this.http.get(`${environment.apiUrl}/project/fields/${action.payload.projectId}`).pipe(
          map((fields: IField[]) => {
            return FieldAction.FieldsLoadedAction({ payload: { fields } });
          }),
          catchError((error: Error) => {
            return of(FieldAction.ErrorFieldsAction(error));
          })
        )
      )
    )
  );
  RemoveField$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(FieldAction.BeginRemoveFieldAction),
      mergeMap(action =>
        this.http.delete(`${environment.apiUrl}/field/fieldId/${action.payload._id}`).pipe(
          map(() => {

            return FieldAction.RemoveFieldAction({ payload: action.payload });
          }),
          catchError((error: Error) => {
            return of(FieldAction.ErrorFieldsAction(error));
          })
        )
      )
    )
  );
  UpdateField$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(FieldAction.BeginUpdateFieldAction),
      mergeMap(action =>
        this.http.put(`${environment.apiUrl}/field`, action.payload).pipe(
          map((field: IField) => {
            return FieldAction.UpdateFieldAction({ payload: field });
          }),
          catchError((error: Error) => {
            return of(FieldAction.ErrorFieldsAction(error));
          })
        )
      )
    )
  );

  FetchSelectedField$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(FieldAction.BeginFetchSelectedFieldAction),
      mergeMap(action => {
        return this.http.get(`${environment.apiUrl}/field/fieldId/${action.payload.fieldId}`).pipe(
          map((field: IField) => {
            return FieldAction.SuccessFetchSelectedFieldAction({ payload: field });
          }),
          catchError((error: Error) => {
            return of(FieldAction.ErrorFieldsAction(error));
          })
        );
      }
      )
    ),
  );

  CreateField$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(FieldAction.BeginCreateFieldAction),
      mergeMap(action => {
        return this.http.post(`${environment.apiUrl}/field`, action.payload.field).pipe(
          map((field: IField) => {
            return FieldAction.AddFieldsAction({ payload: { projectTypeId: action.payload.projectTypeId, fields: [field], entityType: action.payload.entityType } });
          }),
          catchError((error: Error) => {
            return of(FieldAction.ErrorFieldsAction(error));
          })
        ); }
      )
    ),
  );
}

